import React from 'react'
import PropTypes from 'prop-types'
import { AppBar, Toolbar, Avatar, Box, Select, MenuItem, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { styles } from '../../classes/Styles'
import { ACQUISITION_PREMIERE, ACQUISITION_ROLLING } from '../../constants/commons'

class AudienceAcquisitionHeaderComponent extends React.Component {
  static propTypes = {
    homepage: PropTypes.object,
    history: PropTypes.object,
    pathname: PropTypes.string,
    setSelectedNetwork: PropTypes.func,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    audienceAcquisition: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      selectedNetwork: ''
    }
  }

  componentDidMount () {
    if (this.props.homepage.details && this.props.homepage.details.network_entities.length > 0) {
      this.updateSelectedNetwork()
    }
    if (this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_acquisition_network) {
      this.setState({ selectedNetwork: this.props.audienceAcquisition.details.audience_acquisition_network.display_name})
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.shortcut) {
      if (prevProps.audienceAcquisition != this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_acquisition_network) {
        this.setState({ selectedNetwork: this.props.audienceAcquisition.details.audience_acquisition_network.display_name})
      }
    } else {
      if (prevProps.audienceAcquisition !== this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_acquisition_network) {
        this.setState({ selectedNetwork: this.props.audienceAcquisition.details.audience_acquisition_network.display_name})
      }
    }
  }

  updateSelectedNetwork = () => {
    let defaultNetwork = this.props.homepage.details.network_entities.filter(n => n.is_default)
    this.setState({ selectedNetwork: defaultNetwork[0].network_label })
    this.props.setSelectedNetwork(defaultNetwork[0].network_label)
  }

  changeNetwork = (id, name) => {
    this.setState({ selectedNetwork: name})
    this.props.setSelectedNetwork(name)
    if (this.props.pathname.includes(ACQUISITION_ROLLING)) {
      this.props.history.push(`/insights/acquisition/${id}/rolling`)
    } else if (this.props.pathname.includes(ACQUISITION_PREMIERE)) {
      this.props.history.push(`/insights/acquisition/${id}/premiere`)
    }
  }

  render () {
    const { homepage } = this.props
    let networkEntities = homepage.details && homepage.details.network_entities && homepage.details.network_entities.sort((a, b) => (a.network_label < b.network_label) ? -1 : (a.network_label > b.network_label) ? 1 : 0)
    return (
      <AppBar position="static" color="transparent" elevation={0} className="header">
        <Toolbar disableGutters={true} justify="center">
          <Avatar alt="Page title icon" src="/static/images/acquisition-main.png" variant="square" className="titleIcon"></Avatar>
          { (this.props.shortcut || (networkEntities && networkEntities.length === 1)) &&
            <Box pl={1} className='shortcutTitle'>
              <Typography>
                <span className="title">{this.state.selectedNetwork}</span>
              </Typography>
            </Box>
          }
          { (!this.props.shortcut && (networkEntities && networkEntities.length > 1)) &&
            <Box pl={1}>
              <Select
                value={this.state.selectedNetwork}
                >
                { networkEntities && networkEntities.map(network => {
                  return (
                    <MenuItem value={network.network_label} key={network.audience_acquisition_entity_id} onClick={() => this.changeNetwork(network.audience_acquisition_entity_id, network.network_label)}>
                      <span className="title">{network.network_label}</span>
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>
          }
        </Toolbar>
      </AppBar>
    )
  }
}

export default withStyles(styles)(AudienceAcquisitionHeaderComponent)
